<template>
  <div>
    <router-view class="view"></router-view>
  </div>
</template>

<script>

export default {
  name: 'body_print',
  components: {

  },
  data() {
    return {
    };
  },
  computed: {

  },
  watch: {
  },
  created() {

  },
  methods: {
  }
};
</script>

